export function jwtToJson(token) {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
}

export function isV4Compatible(token) {
  const jsonToken = jwtToJson(token);
  return Boolean(
    jsonToken &&
    jsonToken.scp &&
    jsonToken.scp.includes("bonus:all:read") &&
    jsonToken.scp.includes("mdms:uberprofile:read"),
  );
}

export function getRequestUrl(isV4Enabled, token, v3Path, v4Path) {
  // If the token is a JWT, use the V4 API
  return isV4Enabled && isV4Compatible(token) ? v4Path : v3Path;
}
